import React from 'react';
import { Link } from 'react-router-dom';
import { defineMessages, FormattedMessage } from 'react-intl';
import { ORIGIN_ADDRESS, RETURN_ADDRESS, REQUIRES_EMAIL } from './constants';
import { WAREHOUSE_SETTINGS_URL } from '../../../pages/settings/ship-from-locations/constants';

export const errorMessages = defineMessages({
  [ORIGIN_ADDRESS]: {
    defaultMessage: 'Incomplete pickup address. <Link>Edit</Link>',
    id: '5uaV0e',
    description: 'ShipFrom Dropdown > Incomplete pickup address error message',
  },
  [RETURN_ADDRESS]: {
    defaultMessage: 'Incomplete return address. <Link>Edit</Link>',
    id: 'WQQNw/',
    description: 'ShipFrom Dropdown > Incomplete return address error message',
  },
  [REQUIRES_EMAIL]: {
    defaultMessage: 'Email address required on Ship From <Link>Edit</Link>',
    id: 'Q2j+Iv',
    description: 'Error message in single order flow to let users know they need to enter an email',
  },
});

export const generateAddressFormattedMessage = (address) => (
  <FormattedMessage
    {...errorMessages[address]}
    values={{
      Link: (text) => (
        <Link
          to={{
            pathname: WAREHOUSE_SETTINGS_URL,
            state: WAREHOUSE_SETTINGS_URL,
          }}
        >
          {text}
        </Link>
      ),
    }}
  />
);
